import React from "react";

import { Add as AddIcon } from '@vedmarket/ui-kit';
import IconButton from "@mui/material/IconButton";

import LockedIconButton from 'components/common/locked-icon-button';
import {useCalculationReadOnly} from '../../../../../../../../calculation-read-only';

import './new-button.scss';

const NewButton = ( { append, initialValues } : CalculatorPaymentNewButtonProps ) => {

  const readOnly = useCalculationReadOnly();

  if (readOnly) {
    return (
      <LockedIconButton
        className='payments-new-button payments-new-button_locked'
        sx={{
          marginLeft: '8px',
          flexShrink: 0,
        }}
      >
        <AddIcon />
      </LockedIconButton>
    );
  }

  return (
    <IconButton
      onClick={() => {
        append(initialValues)
      }}
      className='payments-new-button'
      sx={{
        marginLeft: '8px',
        flexShrink: 0,
      }}
    >
      <AddIcon />
    </IconButton>
  );
}

export default NewButton
